import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { createLocalizedPath } from '../../utils/languageUtils'
import { resolvePreferredLanguage } from '../../utils/geoLanguage'

/**
 * Редирект на языковую версию по геолокации (или сохранённому выбору пользователя).
 */
function GeoLanguageRedirect({ path = '/' }) {
  const location = useLocation()
  const [target, setTarget] = useState(null)

  useEffect(() => {
    let cancelled = false

    resolvePreferredLanguage().then((lang) => {
      if (!cancelled) {
        setTarget(createLocalizedPath(path, lang))
      }
    })

    return () => {
      cancelled = true
    }
  }, [path])

  if (!target) {
    return (
      <div className="geo-redirect-loading" aria-live="polite">
        {null}
      </div>
    )
  }

  return (
    <Navigate
      to={`${target}${location.search}${location.hash}`}
      replace
    />
  )
}

export default GeoLanguageRedirect
